import { useEffect } from 'react'
import { useClientPreferences } from '../../context/useClientPreferences'
import { AudioCueService } from '../../services/aliveness/AudioService'
import { HapticService } from '../../services/aliveness/HapticService'
import { subscribeSensoryEvents } from '../../services/aliveness/SensoryEventBus'

const prefersReducedMotion = () =>
  typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches

export const AlivenessBridge = () => {
  const { preferences, isMobileViewport } = useClientPreferences()

  useEffect(() => {
    const sensoryEnabled = preferences.soundEnabled !== false || preferences.hapticEnabled !== false
    if (!sensoryEnabled) {
      HapticService.configure({
        enabled: false,
        reducedMotion: true,
        tier: 'LOW',
      })
      AudioCueService.configure({
        enabled: false,
        reducedMotion: true,
        volume: 0,
      })
      return
    }
    const reducedMotion = preferences.animationProfile === 'REDUCED_MOTION' || prefersReducedMotion()
    const highFidelity = preferences.animationProfile === 'FLUID'
      && (!isMobileViewport || preferences.highFidelityEffectsEnabled === true)
    HapticService.configure({
      enabled: preferences.hapticEnabled !== false,
      reducedMotion,
      tier: highFidelity ? 'HIGH' : 'LOW',
    })
    AudioCueService.configure({
      enabled: preferences.soundEnabled !== false,
      reducedMotion,
      volume: highFidelity ? 0.46 : 0.32,
    })
  }, [isMobileViewport, preferences])

  useEffect(() => {
    const sensoryEnabled = preferences.soundEnabled !== false || preferences.hapticEnabled !== false
    if (!sensoryEnabled) return undefined
    const unlock = () => AudioCueService.unlock()
    window.addEventListener('pointerdown', unlock, { once: true, passive: true })
    window.addEventListener('keydown', unlock, { once: true })
    const unsubscribe = subscribeSensoryEvents((event) => {
      void HapticService.handle(event)
      void AudioCueService.handle(event)
    })
    return () => {
      window.removeEventListener('pointerdown', unlock)
      window.removeEventListener('keydown', unlock)
      unsubscribe()
    }
  }, [preferences.soundEnabled, preferences.hapticEnabled])

  return null
}
